
import Vue, { PropType } from 'vue'
import { Toilet, ToiletType } from '@/models'
import BaseSingleCheckbox from '@/components/BaseBoolCheckbox.vue'

export type Option = {
  toiletId: string;
  checked: boolean;
}

export default Vue.extend({
  name: 'WebsitePublicPlaceEditListItem',

  components: {
    BaseSingleCheckbox
  },

  props: {
    name: String as PropType<string>,
    toilet: Object as PropType<Toilet>,
    value: Array as PropType<Array<Option>>
  },

  computed: {
    bindValue: {
      get (): Option | undefined {
        return this.value.find(v => v.toiletId === this.toilet.id)
      },

      set (value: boolean): void {
        const v = this.value.find(v => v.toiletId === this.toilet.id)
        if (v) {
          v.checked = value === true
        }
        this.$emit('set', this.value)
      }
    },

    rowClassText(): string {
      const value = this.value.find(v => v.toiletId === this.toilet.id)
      return value?.checked === true ? 'checked' : 'unchecked'
    },

    toiletTypeText(): string {
      switch (this.toilet?.toiletType) {
        case ToiletType.FOR_MAN:
          return '男性トイレ'
        case ToiletType.FOR_WOMAN:
          return '女性トイレ'
        case ToiletType.UNISEX:
          return '共用'
        case ToiletType.MULTI_PURPOSE:
          return '多目的トイレ'
        default:
          return '不明'
      }
    },

    numOfBoxesText(): string {
      return String(this.toilet?.boxesCount || 0)
    }
  }
})
